// extracted by mini-css-extract-plugin
module.exports = {"container":"MNewSelect_container__2Anl5","container--invalid":"MNewSelect_container--invalid__nYyM7","icon":"MNewSelect_icon__2oPzd"};